// Mobile buy bar: reveals itself once the main add-to-cart button scrolls out of view.
class SStickyAtc extends HTMLElement {
  #observer;

  connectedCallback() {
    const targetId = this.dataset.watch;
    const target = targetId ? document.getElementById(targetId) : null;
    this.#setVisible(false);
    if (!target || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(
      ([entry]) => {
        // Only show after the buyer has scrolled past the button, not before reaching it.
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.#setVisible(scrolledPast);
      },
      { threshold: 0 }
    );
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #setVisible(visible) {
    this.toggleAttribute('data-visible', visible);
    // Hidden bar leaves the tab order and the accessibility tree.
    this.inert = !visible;
    this.setAttribute('aria-hidden', String(!visible));
  }
}

if (!customElements.get('s-sticky-atc')) customElements.define('s-sticky-atc', SStickyAtc);
